import axios, { type Method } from 'axios'

export class ValidationFailedError extends Error {
  constructor(readonly errors: Record<string, string[]>) {
    super('The submitted data was rejected.')
    this.name = 'ValidationFailedError'
  }
}

function submittedErrors(data: unknown): Record<string, string[]> {
  return (data as { errors?: Record<string, string[]> } | null)?.errors ?? {}
}

/**
 * Sends through the shared axios instance so the 419 retry from bootstrap.ts applies: an autosave
 * that outlives the session token is replayed against a fresh one instead of failing the write.
 */
export async function requestJson<TResponse = void>(method: Method, url: string, payload: unknown): Promise<TResponse> {
  try {
    const response = await axios.request<TResponse>({ method, url, data: payload })

    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 422) {
      throw new ValidationFailedError(submittedErrors(error.response.data))
    }

    throw error
  }
}
